import { TenantIntegration, TenantIntegrationApiOutput } from "types/tenant-integration"

export function denormalizeIntegration(
    integrationDTO: TenantIntegrationApiOutput
): TenantIntegration {

    const {
        id,
        clientSecret: client_secret,
        connectedAccountId: connected_account_id,
        integrationId: integration_id,
        locationId: location_id,
        locationName: location_name,
        businessEmail: business_email,
        businessName: business_name
    } = integrationDTO

    const integration = {
        id: integration_id
    }

    const location = {
        id: location_id,
        name: location_name
    }

    return {
        id,
        business_email,
        business_name,
        client_secret,
        connected_account_id,
        integration,
        location
    }
}    